/* Preview lettering stays in the DOM only. Existing Shopify product forms own order personalization. */
(() => {
  document.addEventListener('input', (event) => {
    if (!(event.target instanceof HTMLInputElement) || !event.target.matches('[data-bgv-name]')) return;
    const preview = event.target.closest('[data-bgv-personalize]')?.querySelector('[data-bgv-name-preview]');
    if (preview) {
      preview.textContent = event.target.value.trim() || 'Oliver';
      preview.style.fontSize = event.target.value.length > 14 ? '28px' : '';
    }
  });
  const closeMenus = (restoreFocus = false) => {
    document.querySelectorAll('.bgv-mobile-menu[open]').forEach(menu => {
      menu.open = false;
      if (restoreFocus) menu.querySelector('summary')?.focus();
    });
  };
  document.addEventListener('keydown', event => { if (event.key === 'Escape') closeMenus(true); });
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    if (!event.target.closest('.bgv-mobile-menu') || event.target.closest('.bgv-mobile-menu a')) closeMenus();
  });
  document.addEventListener('shopify:section:unload', () => closeMenus());
})();
